module.exports = __webpack_public_path__ + "static/media/Photo.e9486f52.svg";